import {useEffect} from "react";
import {DialogM} from "@common/components/alert/dialog/Dialog";


export const renderGuide = (browser, missing = 'camera') => {
    const permissionText =
        missing === 'both'
            ? 'du microphone et de la caméra'
            : missing === 'microphone'
            ? 'du microphone'
            : 'de la caméra'
    const commonDialogParams = {
        champion: "abou",
        variant: "main",
        text1: `Active les permissions ${permissionText} dans les paramètres de ton navigateur, puis actualise la page.`,
        buttonText1: 'Actualiser',
        onPress: () => {
            window.location.reload();
        },
        buttonText2: 'Ignorer'
    };

    switch (browser) {
        case 'Chrome':
            return DialogM.show({
                ...commonDialogParams,
                text2: "Clique sur l'icône à gauche de la barre d'adresse.\n Cherche \"Microphone\" et \"Caméra\" dans le menu déroulant et sélectionne \"Autoriser\".\n\n Si le problème persiste, vérifie également les paramètres de confidentialité et de sécurité de ton système."
            });
        case 'Firefox':
            return DialogM.show({
                ...commonDialogParams,
                text2: "Clique sur l'icône de la caméra dans la barre d'adresse.\n Choisis \"Autoriser\" dans le menu déroulant.\n\n Si le problème persiste, vérifie également les paramètres de confidentialité et de sécurité de ton système."
            });
        case 'Safari':
            return DialogM.show({
                ...commonDialogParams,
                text2: "Ouvre les Réglages Safari.\n Clique sur l'onglet \"Sites web\".\n Sous \"Micro\" et \"Caméra\", sélectionne \"Autoriser\" pour app.masteur.com\n\n Si le problème persiste, vérifie également les paramètres de confidentialité et de sécurité de ton système."
            });
        case 'Edge':
            return DialogM.show({
                ...commonDialogParams,
                text2: "Clique sur l'icône cadenas à gauche de l'URL.\n Sous \"Microphone\" et \"Caméra\", sélectionne \"Autoriser\" dans le menu déroulant.\n\n Si le problème persiste, vérifie également les paramètres de confidentialité et de sécurité de ton système."
            });
        default:
            return DialogM.show({
                ...commonDialogParams,
                text2: "..."
            });
    }
};
const PermissionsManager = ({isDenied, setIsDenied, permissionsChecked, setPermissionsChecked}) => {


    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();
        let browser = '';
        if (userAgent.includes('chrome')) {
            browser = 'Chrome';
        } else if (userAgent.includes('firefox')) {
            browser = 'Firefox';
        } else if (userAgent.includes('safari')) {
            browser = 'Safari';
        } else if (userAgent.includes('edge')) {
            browser = 'Edge';
        } else {
            browser = 'Navigateur Inconnu';
        }

        // Request BOTH cam + mic upfront so the browser prompts for both
        // permissions in the pre-call screen (P-1677). Asking only for video
        // left users with a stuck "!" on the mic icon until they joined the
        // live — they had no way to grant the mic permission from pre-call.
        // Bonus: the mic permission grant also acts as a sticky user gesture
        // that unblocks Chrome's autoplay policy for <audio> elements created
        // later by LiveKit (RoomAudioRenderer).
        navigator.mediaDevices.getUserMedia({video: true, audio: true})
            .then(stream => {
                // Stop tracks immediately after permission check to release the devices
                stream.getTracks().forEach(track => track.stop());
                setPermissionsChecked(true);
                setIsDenied(false);
            })
            .catch(error => {
                setPermissionsChecked(true);
                setIsDenied(true);
            });
    }, [])


    return null
}

export default PermissionsManager;